const TermsOfService = () => (
    <div style={{ fontSize: 13, lineHeight: 1.9 }}>
        <p style={{ marginBottom: 16 }}>
            <strong>
                생육관리시스템 서비스(이하 "서비스")는 농지운영을 도울 수 있는
                소프트웨어 플랫폼을 제공합니다.
            </strong>
            <br />
            서비스 이용자는 관리자로부터 요청된 농작업을 확인하고, 작업 내용을
            저장합니다.
        </p>

        {/* ── 제1장 ── */}
        <h4 style={{ marginTop: 20, marginBottom: 8 }}>제 1장 총칙</h4>

        <p>
            <strong>제1조 목적</strong>
        </p>
        <p style={{ marginBottom: 12 }}>
            이 약관은 "(주) 에이아이에스"(이하 "회사")가 온라인으로 제공하는
            생육관리시스템 서비스(이하 "서비스")의 이용조건 및 이용하는 "이용자"
            간의 권리·의무·기타 필요한 제반 사항을 정하는데 그 목적이 있습니다.
        </p>

        <p>
            <strong>제2조 용어정의</strong>
        </p>
        <p>이 약관에서 사용하는 용어의 정의는 다음과 같습니다.</p>
        <ol style={{ paddingLeft: 20, marginBottom: 12 }}>
            <li style={{ marginBottom: 6 }}>
                "서비스"란 "이용자"가 소속된 "제휴사"의 업무를 효율적으로
                전달받을 수 있는 용도로써, 생육관리시스템의 모바일
                어플리케이션에서 제공되는 인터넷 사이트 및 온라인 상의 모든
                서비스를 말합니다. 구현되는 단말기(PC, 모바일 등의 각종 유무선
                장치 포함)와 상관없이 제공되는 모든 서비스를 포함합니다.
            </li>
            <li style={{ marginBottom: 6 }}>
                "제휴사"란 회사와 계약한 단체를 의미합니다.
            </li>
            <li style={{ marginBottom: 6 }}>
                "관리자"란 이용자에게 작업 내역을 할당, 관리, 제한할 수 있는
                역할을 하며, 이용자를 등록·제거할 수 있습니다.
            </li>
            <li style={{ marginBottom: 6 }}>
                "이용자"란 제휴사 소속원으로써 서비스를 이용하기 위해 소정의
                절차를 거쳐 회사와 서비스 이용계약을 체결하고 이 약관에 따라
                회사가 제공하는 서비스를 최종적으로 이용하는 자를 말합니다.
            </li>
            <li style={{ marginBottom: 6 }}>
                "회사"란 "주식회사 에이아이에스"를 말합니다.
            </li>
        </ol>

        <p>
            <strong>제3조 약관의 게시와 개정</strong>
        </p>
        <ol style={{ paddingLeft: 20, marginBottom: 12 }}>
            <li style={{ marginBottom: 6 }}>
                "회사"는 이 약관의 내용을 이용자가 알 수 있도록 서비스
                홈페이지에 게시합니다.
            </li>
            <li style={{ marginBottom: 6 }}>
                "회사"가 이 약관을 개정할 경우에는 적용일자, 개정사유, 개정 전후
                내용 등을 명시하여 현행 약관과 함께 적용일로부터 최소 7일 전부터
                적용일 전일까지 알립니다. 다만, 이용자에게 불리하거나 중대한
                사항인 경우 최소 30일 전부터 휴대전화, 전자우편 또는
                문자메시지로 알립니다.
            </li>
            <li style={{ marginBottom: 6 }}>
                "회사"가 이 약관을 개정할 때 이용자가 개정 약관 시행일까지
                거절의사를 표시하지 않는다면 개정 약관에 동의한 것으로 합니다.
            </li>
            <li style={{ marginBottom: 6 }}>
                "이용자"가 개정 약관의 적용에 동의하지 않는 경우, "이용자"는
                이용계약 해지를 요청할 수 있습니다.
            </li>
        </ol>

        <p>
            <strong>제4조 약관의 해석</strong>
        </p>
        <p style={{ marginBottom: 12 }}>
            이 약관에서 정하지 아니한 사항과 해석에 관하여는 관련 법령 또는
            회사가 정한 운영정책 및 규칙 등의 규정에 따릅니다.
        </p>

        {/* ── 제2장 ── */}
        <h4 style={{ marginTop: 20, marginBottom: 8 }}>
            제 2장 이용계약의 체결
        </h4>

        <p>
            <strong>제5조 이용신청 및 방법</strong>
        </p>
        <ol style={{ paddingLeft: 20, marginBottom: 12 }}>
            <li style={{ marginBottom: 6 }}>
                서비스의 이용을 신청하는 자(이하 "신청자")는 회사의 서비스
                회원가입 화면에서 필요한 정보를 입력하고 약관에 동의함으로써
                이용을 신청할 수 있습니다.
            </li>
            <li style={{ marginBottom: 6 }}>
                회원이 온라인에서 본 약관의 "동의하기" 버튼을 클릭하였을 경우 본
                약관의 내용을 모두 읽고 충분히 이해하였으며, 그 적용에 동의한
                것으로 봅니다.
            </li>
            <li style={{ marginBottom: 6 }}>
                신청자는 본인의 실명 및 실제 정보를 기재해야 합니다. 타인의
                명의를 도용하거나 거짓 정보를 기재한 경우 이 계약에서 정한
                권리를 주장할 수 없고, "회사"는 이를 이유로 이용을 제한하거나
                제휴사와 계약을 중지 및 해지할 수 있습니다.
            </li>
        </ol>

        <p>
            <strong>제6조 서비스 이용신청의 승인과 제한</strong>
        </p>
        <ol style={{ paddingLeft: 20, marginBottom: 12 }}>
            <li style={{ marginBottom: 6 }}>
                이용계약은 "이용자"가 본 약관에 동의한 다음 "회사"가 정한 절차에
                따라 이용신청을 하고, 관리자가 승인함으로써 체결됩니다.
            </li>
            <li style={{ marginBottom: 6 }}>
                관리자는 다음 각 호에 해당하는 신청에 대하여 승인하지 않거나
                사후에 이용계약을 해지할 수 있습니다.
                <ol type="a" style={{ paddingLeft: 18, marginTop: 6 }}>
                    <li>
                        이용자가 본 약관에 의하여 자격을 상실한 적이 있는 경우
                        (단, 관리자의 재가입 승낙을 얻은 경우 예외)
                    </li>
                    <li>실명이 아니거나 타인의 명의를 이용한 경우</li>
                    <li>
                        허위의 정보를 기재하거나 신청절차를 준수하지 않은 경우
                    </li>
                    <li>이용자의 귀책사유로 승인이 불가능한 경우</li>
                    <li>
                        서비스 관련 설비의 여유가 없거나 정상적인 업무 제공이
                        어렵다고 판단되는 경우
                    </li>
                </ol>
            </li>
            <li style={{ marginBottom: 6 }}>
                회사는 다음 각 호에 해당하는 경우 이용신청에 제한을 둘 수
                있습니다.
                <ol type="a" style={{ paddingLeft: 18, marginTop: 6 }}>
                    <li>제휴사가 서비스 이용요금을 납부하지 않는 경우</li>
                    <li>
                        최근 3개월 내 이용제한 기록이 있는 이용자가 신청하는
                        경우
                    </li>
                    <li>미성년자가 법정대리인의 동의를 얻지 않은 경우</li>
                    <li>
                        관련 법령에서 금지하는 위법행위를 할 목적으로 이용신청을
                        하는 경우
                    </li>
                    <li>
                        신청자가 이전에 이용자의 자격을 상실한 사실이 있는 경우
                    </li>
                </ol>
            </li>
            <li style={{ marginBottom: 6 }}>
                이용자는 이용신청 시 기재한 사항이 변경되었을 경우에 서비스를
                통해 수정하거나 전자우편, 그 밖의 방법으로 회사에 변경사항을
                알려야 합니다.
            </li>
        </ol>

        {/* ── 제3장 ── */}
        <h4 style={{ marginTop: 20, marginBottom: 8 }}>
            제 3장 계약 당사자의 의무
        </h4>

        <p>
            <strong>제7조 회사의 의무</strong>
        </p>
        <ol style={{ paddingLeft: 20, marginBottom: 12 }}>
            <li style={{ marginBottom: 6 }}>
                회사는 이용자가 서비스를 원활히 이용할 수 있도록 안정적인
                서비스를 지속적으로 제공하여야 합니다.
            </li>
            <li style={{ marginBottom: 6 }}>
                회사는 이용자로부터 제기된 의견이나 불만이 정당하다고 인정되는
                경우 합리적인 기간 내에 신속하게 해결하며, 곤란한 경우 그 사유와
                처리일정을 이용자에게 통지합니다.
            </li>
            <li style={{ marginBottom: 6 }}>
                회사는 이용자의 정보보호를 위해 보안시스템을 갖추고 이용자 정보
                처리방침을 공시 및 준수합니다. 이용자의 동의 없이 이용자 정보를
                제3자에게 제공하거나 서비스 제공 목적 외의 용도로 이용할 수
                없습니다.
            </li>
            <li style={{ marginBottom: 6 }}>
                회사는 서비스 개선 과정에서 장애가 생기거나 데이터가 멸실된 경우
                부득이한 사유가 없는 한 지체 없이 수리 또는 복구하여야 합니다.
            </li>
        </ol>

        <p>
            <strong>제8조 이용자의 의무</strong>
        </p>
        <ol style={{ paddingLeft: 20, marginBottom: 12 }}>
            <li style={{ marginBottom: 6 }}>
                이용자는 이용계약에 정해진 기일까지 업무수행을 완료해야 하며,
                변경사항 발생 시 지체 없이 제휴사 또는 회사에 알려야 합니다.
            </li>
            <li style={{ marginBottom: 6 }}>
                이용자는 다음 각 호의 행위를 해서는 안 됩니다.
                <ol type="a" style={{ paddingLeft: 18, marginTop: 6 }}>
                    <li>이용신청 또는 변경 시 허위 내용의 기재</li>
                    <li>
                        타인의 정보나 명의를 도용하거나 부정하게 사용하는 행위
                    </li>
                    <li>
                        타인의 개인정보를 동의 없이 수집, 저장, 사용하는 행위
                    </li>
                    <li>
                        회사 또는 제3자의 저작권 등 지적재산권을 침해하는 행위
                    </li>
                    <li>
                        회사 또는 제3자의 명예를 훼손하거나 업무를 방해하는 행위
                    </li>
                    <li>
                        외설, 폭력적, 비방적인 내용 등 공서양속에 반하는 내용을
                        서비스에 게시하거나 전송하는 행위
                    </li>
                    <li>
                        회사의 동의 없이 영리를 목적으로 서비스를 이용하는 행위
                    </li>
                    <li>
                        악성 프로그램의 배포 또는 시스템 취약점을 악용하는 행위
                    </li>
                    <li>
                        비정상적인 방법으로 서비스를 이용하거나 시스템에
                        접근하는 행위
                    </li>
                    <li>
                        리버스엔지니어링, 디컴파일, 디스어셈블 등을 통하여
                        서비스를 복제·변형하는 행위
                    </li>
                    <li>
                        본 서비스를 제3자가 제공하는 것으로 오인하게 하는 행위
                    </li>
                    <li>
                        그 밖에 관련 법령에서 금지하거나 사회질서에 반하는 행위
                    </li>
                </ol>
            </li>
            <li style={{ marginBottom: 6 }}>
                이용자는 아이디와 비밀번호 등 서비스 접속 정보에 대하여
                관리책임이 있으며, 도용 또는 제3자의 이용으로 인해 발생한 문제의
                책임은 이용자에게 있습니다.
            </li>
            <li style={{ marginBottom: 6 }}>
                이용자는 이 계약의 규정, 이용안내 및 회사로부터 통지받은
                제반사항을 확인하고 준수하여야 합니다.
            </li>
        </ol>

        {/* ── 제4장 ── */}
        <h4 style={{ marginTop: 20, marginBottom: 8 }}>제 4장 서비스의 이용</h4>

        <p>
            <strong>제9조 서비스의 제공 및 변경</strong>
        </p>
        <ol style={{ paddingLeft: 20, marginBottom: 12 }}>
            <li style={{ marginBottom: 6 }}>
                회사는 필요한 경우 정기점검 등을 실시할 수 있으며, 서비스 중단이
                필요한 경우 사전에 이용자에게 통지합니다. 다만, 긴급 점검 시
                사전 통지 없이 진행할 수 있습니다.
            </li>
            <li style={{ marginBottom: 6 }}>
                회사는 서비스에 장애가 발생한 경우 지체 없이 수리 또는 복구해야
                합니다.
            </li>
            <li style={{ marginBottom: 6 }}>
                회사는 정책상, 운영상, 기술상의 필요에 따라 서비스의 전부 또는
                일부를 변경할 수 있으며, 변경 시 이용자에게 통지합니다.
            </li>
        </ol>

        <p>
            <strong>제10조 서비스 이용 요금</strong>
        </p>
        <ol style={{ paddingLeft: 20, marginBottom: 12 }}>
            <li style={{ marginBottom: 6 }}>
                서비스 이용요금 및 납부 방법은 서비스에 게재한 바에 따릅니다.
            </li>
            <li style={{ marginBottom: 6 }}>
                요금과금 기준 변경 시 최소 30일 전부터 전화, 전자우편 또는
                문자메시지 등을 통해 제휴사에게 알립니다.
            </li>
        </ol>

        <p>
            <strong>제11조 요금납부</strong>
        </p>
        <ol style={{ paddingLeft: 20, marginBottom: 12 }}>
            <li style={{ marginBottom: 6 }}>
                구체적인 서비스 이용요금은 개별 상품별 운영정책에 따릅니다.
            </li>
            <li style={{ marginBottom: 6 }}>
                제휴사가 선택한 결제 수단을 통해 요금납부가 이루어집니다.
            </li>
            <li style={{ marginBottom: 6 }}>
                일정 기간 내에 요금을 납부하지 않을 경우, 서비스 이용이 정지될
                수 있습니다.
            </li>
        </ol>

        <p>
            <strong>제12조 환불</strong>
        </p>
        <ol style={{ paddingLeft: 20, marginBottom: 12 }}>
            <li style={{ marginBottom: 6 }}>
                제휴사가 서비스 이용 중 해지를 요청하는 경우 남은 기간 비용은
                환급 처리할 수 있으며, 해지수수료가 적용될 수 있습니다.
            </li>
            <li style={{ marginBottom: 6 }}>
                회사는 요금의 과·오납이 있는 경우 이를 제휴사에게 반환하고,
                회사의 귀책사유인 경우 법정 이자율을 부가하여 반환하거나 다음 달
                이용금액에서 정산합니다.
            </li>
        </ol>

        {/* ── 제5장 ── */}
        <h4 style={{ marginTop: 20, marginBottom: 8 }}>
            제 5장 서비스의 이용제한 및 종료
        </h4>

        <p>
            <strong>제13조 서비스 이용제한</strong>
        </p>
        <ol style={{ paddingLeft: 20, marginBottom: 12 }}>
            <li style={{ marginBottom: 6 }}>
                회사는 이용자가 이용요금을 미납하거나, 약관에 위반하는 행위를 한
                경우 서비스 이용을 제한할 수 있습니다.
            </li>
            <li style={{ marginBottom: 6 }}>
                이용을 제한하는 경우 사유, 이용제한 기간, 이의신청 방법을 사전에
                이용자에게 통지합니다.
            </li>
        </ol>

        <p>
            <strong>제14조 이용자의 탈퇴</strong>
        </p>
        <ol style={{ paddingLeft: 20, marginBottom: 12 }}>
            <li style={{ marginBottom: 6 }}>
                이용자는 서비스 내 탈퇴 기능 혹은 회사·제휴사에 별도 연락을 통해
                탈퇴 신청을 할 수 있습니다.
            </li>
            <li style={{ marginBottom: 6 }}>
                제휴사는 탈퇴 신청이 접수되면 지체 없이 처리합니다. 단, 별도의
                채권·채무 관계가 있을 경우 탈퇴 승인이 유보될 수 있습니다.
            </li>
        </ol>

        <p>
            <strong>제15조 제휴사의 계약 해지</strong>
        </p>
        <ol style={{ paddingLeft: 20, marginBottom: 12 }}>
            <li style={{ marginBottom: 6 }}>
                회사는 사업 종료에 따라 서비스를 종료하는 경우 제휴사와 계약을
                해지할 수 있으며, 이는 이용자에 대한 손해배상 청구에 영향을
                미치지 않습니다.
            </li>
            <li style={{ marginBottom: 6 }}>
                회사가 손해를 입은 경우 계약 해지와 관계없이 제휴사에게
                손해배상을 청구할 수 있습니다.
            </li>
        </ol>

        {/* ── 제6장 ── */}
        <h4 style={{ marginTop: 20, marginBottom: 8 }}>
            제 6장 이용자 정보의 보호
        </h4>

        <p>
            <strong>제16조 이용자 정보의 보호와 관리</strong>
        </p>
        <ol style={{ paddingLeft: 20, marginBottom: 12 }}>
            <li style={{ marginBottom: 6 }}>
                회사는 관계 법령이 정하는 바에 따라 이용자의 정보를 보호합니다.
                이용자 정보 보호에 대해서는 관계 법령 및 회사의 개인정보
                처리방침이 적용됩니다.
            </li>
            <li style={{ marginBottom: 6 }}>
                회사는 이용자 정보 노출에 대하여 고의 또는 과실이 없음을 입증한
                경우에 한하여 책임을 지지 않습니다.
            </li>
        </ol>

        <p>
            <strong>제17조 이용자 정보 파기</strong>
        </p>
        <ol style={{ paddingLeft: 20, marginBottom: 12 }}>
            <li style={{ marginBottom: 6 }}>
                회사는 이용 계약이 종료되면 이용자 정보 파기를 위한 통지를
                하여야 합니다.
            </li>
            <li style={{ marginBottom: 6 }}>
                이용자 정보는 복구가 불가능한 방법으로 완전히 파기하여야 합니다.
            </li>
        </ol>

        {/* ── 제7장 ── */}
        <h4 style={{ marginTop: 20, marginBottom: 8 }}>제 7장 손해배상 등</h4>

        <p>
            <strong>제18조 손해배상</strong>
        </p>
        <ol style={{ paddingLeft: 20, marginBottom: 12 }}>
            <li style={{ marginBottom: 6 }}>
                회사가 고의 또는 과실로 이용자에게 손해를 발생시킨 경우에는 이를
                배상해야 합니다.
            </li>
            <li style={{ marginBottom: 6 }}>
                회사의 귀책사유로 이용자가 서비스를 이용하지 못하는 경우, 서비스
                장애 운영지침에 따라 배상합니다. 다만, 4시간 이내에 서비스가
                정상화된 경우는 제외합니다.
            </li>
            <li style={{ marginBottom: 6 }}>
                이용자가 고의 또는 과실로 회사에 손해를 발생시킨 경우에는 그
                손해를 배상해야 합니다.
            </li>
        </ol>

        <p>
            <strong>제19조 면책</strong>
        </p>
        <ol style={{ paddingLeft: 20, marginBottom: 12 }}>
            <li style={{ marginBottom: 6 }}>
                회사는 천재지변, 이용자 시스템 환경의 장애, 네트워크 해킹,
                서비스 점검, 이용자의 고의·과실로 인한 경우 발생한 손해에 대해
                책임을 부담하지 않습니다.
            </li>
            <li style={{ marginBottom: 6 }}>
                회사는 이용자 또는 제3자가 서비스 내에 게시 또는 전송한 정보의
                신뢰도, 정확성 등에 대하여 회사의 고의 또는 과실이 없는 한
                책임이 면제됩니다.
            </li>
            <li style={{ marginBottom: 6 }}>
                회사는 이용자 상호 간 또는 이용자와 제3자 간에 서비스를 매개로
                발생한 분쟁에 대하여 회사의 고의 또는 과실이 없는 한 책임이
                면제됩니다.
            </li>
        </ol>

        <p>
            <strong>제20조 이용자에 대한 통지</strong>
        </p>
        <ol style={{ paddingLeft: 20, marginBottom: 12 }}>
            <li style={{ marginBottom: 6 }}>
                회사는 불특정 다수에 대한 통지를 서비스 접속화면 게시 또는
                홈페이지를 통하여 할 수 있습니다.
            </li>
            <li style={{ marginBottom: 6 }}>
                침해사고, 정보 유출, 서비스 중단·종료, 그 밖에 이용자의 서비스
                이용에 중대한 영향을 미치는 사항은 이용자에게 개별 통지합니다.
            </li>
        </ol>

        <p>
            <strong>제21조 관할 법원</strong>
        </p>
        <p style={{ marginBottom: 12 }}>
            회사와 이용자 간 분쟁으로 소송이 제기되는 경우 이용자의 주소지 또는
            민사소송법이 정한 법원을 관할법원으로 합니다.
        </p>

        <p>
            <strong>제22조 준거법</strong>
        </p>
        <p style={{ marginBottom: 12 }}>
            이 계약의 성립, 효력, 해석 및 이행과 관련하여서는 대한민국법을
            적용합니다.
        </p>

        <p>
            <strong>제23조 양도금지</strong>
        </p>
        <p style={{ marginBottom: 12 }}>
            본 계약의 모든 권리와 의무는 상대방의 서면 승낙 없이는 제3자에게
            양도할 수 없습니다.
        </p>

        <p>
            <strong>제24조 불가항력</strong>
        </p>
        <p style={{ marginBottom: 12 }}>
            불가항력 또는 각 당사자의 통제가 불가능한 사유로 인해 발생한 지연
            또는 계약 조건 불이행에 대해서는 상대방에 대하여 책임을 지지
            않습니다.
        </p>

        <p style={{ marginTop: 24, color: '#888', fontSize: 12 }}>
            공고일자: 2026년 3월 19일 &nbsp;|&nbsp; 시행일자: 2026년 3월 19일
        </p>
    </div>
);

export default TermsOfService;
